const initialState = {
	isFetching: 0
};

export default function loading(state = initialState, action) {
  	switch (action.type) {
		case 'AJAX_REQUEST_INITIATED':
			return { ...state,
				isFetching: state.isFetching + 1
			}
		case 'AJAX_REQUEST_COMPLETED':
			return { ...state,
				isFetching: state.isFetching - 1 < 0 ? 0 : state.isFetching - 1
			}
		case 'RESET_LOADING_REDUCERS':
			return initialState;
	  	default:
	    	return state;
  	}
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/loading.js